export default __webpack_public_path__ + "locales/sr-Latn-RS/ChangeUserTypeDialog.json?hash=47019793d5f790cf914215971ef9802c";